module.exports = __webpack_public_path__ + "static/img/icon-next-circle.9a6604d2.png";